import React, { Fragment } from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useRoute } from '@react-navigation/native';

import { BaseText, Separator, TextTruncated } from '@components';
import { useTutorialsModel } from '@models/Tutorials/TutorialsModel';
import { HubNavigatorRoutePropType } from '@navigation';
import { IS_WEB } from '@utils';

const Container = styled(View)({
  flex: 1,
});

const Title = styled(BaseText)({
  color: '$heading800',
  fontWeight: 'semi',
  variant: IS_WEB ? 'text.xlarge' : 'text.large',
});

const CountText = styled(BaseText)({
  color: '$text400',
  variant: 'text.small',
});

const Description = styled(TextTruncated)({
  color: '$text300',
  variant: 'text.medium',
});

type RoutePropType = HubNavigatorRoutePropType<'Tutorial'>;

export const TutorialPlaylistHeader = observer(() => {
  const { params } = useRoute<RoutePropType>();
  const tutorials = useTutorialsModel();
  const description = tutorials.related.categoryDescription;
  const isDescription = !!description;

  return (
    <Container>
      <Title>{tutorials.related.categoryName}</Title>

      {isDescription && (
        <Fragment>
          <Separator size="$4" />
          <Description numberOfLines={2}>{description}</Description>
        </Fragment>
      )}

      <Separator size="$4" />
      <CountText>{`${tutorials.related.numberInList(params.id)}/${
        tutorials.related.totalCount
      }`}</CountText>
    </Container>
  );
});
